import axios, { AxiosResponse } from 'axios';
import {
  TReportActiveUsersWithNoAccounts,
  TReportBlacklistUsersParams,
  TReportBlacklistUsersRes,
  TReportChurnByDate,
  TReportExpiryDateUserRes,
  TReportNewUserByMonth,
  TReportNewUserByMonthParams,
  TReportUsersWithExtraSession,
  TReportUsersWithTopOfBook,
  TReportActiveUsersByPeriodRes,
  TReportActiveUsersByProductCategoriesRes,
  TReportPaymentByNewVsExistingUsersParams,
  TReportPaymentByNewVsExistingUsersRes,
  TReportIncomeData,
  TReportIncomeParams,
  TReportPaymentsVsRefundsData,
  TReportPaymentsVsRefundsParams,
  TReportPaymentByUsedCouponRes,
  TReportPaymentByUserGroupParams,
  TReportPaymentByUserGroupOption,
  TReportPaymentByUserGroupRes,
  TReportPaymentsByPaymentSystemBreakdownParams,
  TReportPaymentsByPaymentSystemBreakdownRes,
  TReportPaymentsByProductCategoriesBreakdownParams,
  TReportPaymentsByProductCategoriesBreakdownRes,
  TReportPaymentsByProductCategoriesBreakdownOption,
  TReportPaymentsBySignupFormBreakdownParams,
  TReportPaymentsBySignupFormBreakdownRes,
  TReportPaymentsMinusRefundsByCustomerCountryParams,
  TReportPaymentsMinusRefundsByCustomerCountryRes,
  TReportPaymentsByCustomerCityOptionsRes,
  TReportRefundsByCustomerCountryParams,
  TReportRefundsByCustomerCountryRes,
  TReportRefundsByPaymentSystemBreakdownParams,
  TReportRefundsByPaymentSystemBreakdownRes,
  TReportRefundsByProductCategoriesBreakdownParams,
  TReportRefundsByProductCategoriesBreakdownOption,
  TReportRefundsByProductCategoriesBreakdownRes,
  TReportRefundsByUsedCouponParams,
  TReportRefundsByUsedCouponRes,
  TReportRefundsByProductsBreakdownParams,
  TReportRefundsByProductsBreakdownRes,
  TReportTaxData,
  TReportTaxParams,
  TReportTaxRes,
  TReportTaxByCustomerCountryParams,
  TReportTaxByCustomerCountryRes,
  TReportTaxByCustomerStateParams,
  TReportTaxByCustomerStateRes,
  TReportTaxByCustomerStateData,
  TReportProductConversionParams,
  TReportProductConversionRes,
  TReportUserDistributionByCustomFieldByDateParams,
  TReportUserDistributionByCustomFieldByDateRes,
  TReportRefundsRateRes,
  TReportActiveUsersByProductCategoriesPayload,
  TReportActiveUsersByProductPayload,
  TReportActiveUsersByProductRes,
  TReportCommonPayloadWithGroupingAndProducts,
  TCommonReportWithProductsRes,
  TReportCountOfProductPurchaseByPaymentSystemRes,
  TReportCommonPayloadWithGrouping,
  TReportCountOfUserSignupsRes,
  TReportCountOfSignupByCountryRes,
  TReportUserDemographicsParams,
  TReportPaymentDistributionByCustomerCountryData,
  TReportPaymentDistributionByCustomerCountryParams,
  TReportRefundsDistributionByCustomerCountryParams,
  TReportRefundsDistributionByCustomerCountryRes,
  TReportPaymentsByCustomerCityOrCountryPayload,
  TReportPaymentsByCustomerCityOrCountryRes,
  TReportPaymentsByCustomerCountryRes,
  TCommonReportWithProductsData,
  TReportAmountOfRebillsRes,
  TReportAverageLifetimeValueCohortAnalysisParams,
  TReportAverageLifetimeValueCohortAnalysisRes,
  TReportRevenueBreakdownRes,
  TReportTopSellingProductsRes,
  TReportLTVDistributionRes,
  TEcommerceDashboardSummaryRes,
  TEcommerceDashboardChartRes,
  TPayoutDashboardSummaryRes,
  TPayoutDashboardChartRes,
  TReportOldAffiliateClicksRes,
  TReportNewAffiliateClicksRes,
  TReportOldAffiliateCommissionsRes,
  TReportOldAffiliateSaleNumberRes,
  TReportOldAffiliateCommissionsByProductData,
  TReportAffiliatePayoutData,
  TReportAffiliatePayoutParams,
  TReportUserDemographicsRes,
  TReportLeaderBoardParams,
  TReportLeaderBoardRes,
  TReportEvalsToPaParams,
  TReportEvalsToPaRes,
  TReportEvalAccountByMonthParams,
  TReportEvalAccountByMonthRes,
  TReportPANewRenewalResetByMonthParams,
  TReportPANewRenewalResetByMonthRes,
  TPaNewAccountByDateParams,
  TPaNewAccountByDateRes,
  TPaResetParams,
  TPaResetRes,
  TPADailyPLParams,
  TPADailyPLRes,
  TReportEvalAccountAnalysisParams,
  TReportEvalAccountAnalysisRes,
  TBundlesPAAccountsParams,
  TBundlePAAccountRes,
  TReportOneDayProfitParams,
  TReportOneDayProfitRes,
  TActiveLifetimePAParams,
  TActiveLifetimePARes,
  TReportProfitableTradersRes,
  TReportProfitableTradersV2Params,
  TReportProfitableTradersV2Res,
  TPAPlnAnalysisParams,
  TPAPlnAnalysisRes,
  TPaPayoutAnalysisParams,
  TPaPayoutAnalysisRes,
  TExpressPAAccountRefundParams,
  TExpressPAAccountRefundRes,
  TAveragePaymentsByUserGroupRequest,
  TAveragePaymentsByUserGroupResponse,
  TReportAverageAmountByProductsBreakdownParams,
  TReportAverageAmountByProductsBreakdownRes,
  TReportConversionRateByPaymentSystemBreakdownParams,
  TReportConversionRateByPaymentSystemBreakdownRes,
  TReportCreditsSpentByProductsBreakdownParams,
  TReportCreditsSpentByProductsBreakdownRes,
  TReportDownloadByFilesBreakdownFileOption,
  TReportDownloadByFilesBreakdownParams,
  TReportDownloadByFilesBreakdownRes,
  TReportInvoicesBySignupFormOption,
  TReportInvoicesBySignupFormParams,
  TReportInvoicesBySignupFormRes,
  TReportNumberOfPaymentsByBillingPlanRes,
  TReportNumberOfRebillsRes,
  TReportRollingConversionParams,
  TReportRollingConversionRes,
  TReportUserLifetimeRes,
  TReportUsersByUserGroupsRes,
  TPAActivePayoutsAddonsApiRes,
  TPAActivePayoutsAddonsRequest,
  TPayoutsTotalsReportResponse,
  TReportCancelFeedbackData,
  TReportCancelFeedbackRes,
  TStaffFreebieParams,
  TStaffFreebieRes,
} from '@src/types/reports';

export const getNewUserByMonth = async (
  params?: TReportNewUserByMonthParams
): Promise<TReportNewUserByMonth[]> => {
  const { data } = await axios.get('/reports/new-user-by-month/', {
    params,
  });

  return data.data;
};

export const getBlacklistUsers = async (
  params?: TReportBlacklistUsersParams
): Promise<TReportBlacklistUsersRes> => {
  const { data } = await axios.get('/reports/blacklist-users/', {
    params: { ...params, size: 20 },
  });

  return data;
};

export const getUserExpiringEarly = async (
  params?: TReportBlacklistUsersParams
): Promise<TReportExpiryDateUserRes> => {
  const { data } = await axios.get('/reports/user-expiring-early/', {
    params: { ...params, size: 20 },
  });

  return data;
};

export const exportBlacklistUsers = (
  params?: TReportBlacklistUsersParams
): Promise<AxiosResponse<BlobPart>> => {
  return axios.get(`/reports/blacklist-users/excel/`, {
    params,
    responseType: 'blob',
  });
};

export const getActiveUsersWithNoAccounts = async (
  params?: TReportBlacklistUsersParams
): Promise<TReportActiveUsersWithNoAccounts[]> => {
  const { data } = await axios.get('/reports/active-users-with-no-accounts/', {
    params,
  });

  return data;
};

export const getUsersWithExtraSession = async (
  params?: TReportBlacklistUsersParams
): Promise<TReportUsersWithExtraSession[]> => {
  const { data } = await axios.get('/reports/user-with-extra-session/', {
    params,
  });

  return data;
};

export const getUsersWithEurex = async (
  params?: TReportBlacklistUsersParams
): Promise<TReportUsersWithExtraSession[]> => {
  const { data } = await axios.get('/reports/user-with-eurex/', {
    params,
  });

  return data;
};

export const getUsersWithTopOfBook = async (
  params?: TReportBlacklistUsersParams
): Promise<TReportUsersWithTopOfBook[]> => {
  const { data } = await axios.get('/reports/user-with-top-of-book/', {
    params,
  });

  return data;
};

export const getChurnByDate = async (
  params?: TReportBlacklistUsersParams
): Promise<TReportChurnByDate> => {
  const { data } = await axios.get('/reports/churn-by-date/', {
    params,
  });

  return data;
};

export const getActiveUsersByPeriod = async (
  payload: TReportCommonPayloadWithGroupingAndProducts
): Promise<TReportActiveUsersByPeriodRes> => {
  const { data } = await axios.post(
    '/reports/active-users-by-period/',
    payload
  );

  return data;
};

export const exportActiveUsersByPeriod = (
  payload: TReportCommonPayloadWithGroupingAndProducts
): Promise<AxiosResponse<BlobPart>> => {
  return axios.post('/reports/active-users-by-period/export/', payload, {
    responseType: 'blob',
  });
};

export const getOldAffiliateClicks = async (
  payload: TReportCommonPayloadWithGrouping
): Promise<TReportOldAffiliateClicksRes> => {
  const { data } = await axios.post(
    '/reports/amember-affiliate-clicks/',
    payload
  );

  return data;
};

export const exportOldAffiliateClicks = (
  payload: TReportCommonPayloadWithGrouping
): Promise<AxiosResponse<BlobPart>> => {
  return axios.post('/reports/amember-affiliate-clicks/export/', payload, {
    responseType: 'blob',
  });
};

type TAffiliateNumberOfSalesApiRow = {
  report_date: string;
  sales: number;
  previous_period_sales?: number | null;
  previous_year_sales?: number | null;
};

const mapOldAffiliateSaleNumberRow = (row: TAffiliateNumberOfSalesApiRow) => ({
  date: row.report_date,
  sales: Number(row.sales),
  sales_previous:
    row.previous_period_sales === null ||
    row.previous_period_sales === undefined
      ? undefined
      : Number(row.previous_period_sales),
  sales_previous_year:
    row.previous_year_sales === null || row.previous_year_sales === undefined
      ? undefined
      : Number(row.previous_year_sales),
  isTotal: row.report_date === 'TOTAL',
});

export const getOldAffiliateSaleNumber = async (
  payload: TReportCommonPayloadWithGrouping
): Promise<TReportOldAffiliateSaleNumberRes> => {
  const { data } = await axios.post<TAffiliateNumberOfSalesApiRow[]>(
    '/reports/amember/number-of-sales/',
    payload
  );

  return data.map(mapOldAffiliateSaleNumberRow);
};

export const exportOldAffiliateSaleNumber = (
  payload: TReportCommonPayloadWithGrouping
): Promise<AxiosResponse<BlobPart>> => {
  return axios.post('/reports/amember/number-of-sales/export/', payload, {
    responseType: 'blob',
  });
};

export const getNewAffiliateClicks = async (
  payload: TReportCommonPayloadWithGrouping
): Promise<TReportNewAffiliateClicksRes> => {
  const { data } = await axios.post('/reports/new-affiliate-clicks/', payload);

  return data;
};

export const exportNewAffiliateClicks = (
  payload: TReportCommonPayloadWithGrouping
): Promise<AxiosResponse<BlobPart>> => {
  return axios.post('/reports/new-affiliate-clicks/export/', payload, {
    responseType: 'blob',
  });
};

export const getOldAffiliateCommissions = async (
  payload: TReportCommonPayloadWithGrouping
): Promise<TReportOldAffiliateCommissionsRes> => {
  const { data } = await axios.post(
    '/reports/amember/affiliate-programs-commissions/',
    payload
  );

  return data;
};

export const exportOldAffiliateCommissions = (
  payload: TReportCommonPayloadWithGrouping
): Promise<AxiosResponse<BlobPart>> => {
  return axios.post(
    '/reports/amember/affiliate-programs-commissions/export/',
    payload,
    {
      responseType: 'blob',
    }
  );
};

export const getOldAffiliateCommissionsByProduct = async (
  payload: TReportCommonPayloadWithGroupingAndProducts
): Promise<TReportOldAffiliateCommissionsByProductData[]> => {
  const { data } = await axios.post(
    '/reports/amember/affiliate-commissions-by-product/',
    payload
  );

  return data;
};

export const exportOldAffiliateCommissionsByProduct = (
  payload: TReportCommonPayloadWithGroupingAndProducts
): Promise<AxiosResponse<BlobPart>> => {
  return axios.post(
    '/reports/amember/affiliate-commissions-by-product/export/',
    payload,
    {
      responseType: 'blob',
    }
  );
};

type TAffiliatePayoutAmountByUserApiRow = {
  username: string;
  payout: number;
};

const mapAffiliatePayoutAmountByUserRow = (
  row: TAffiliatePayoutAmountByUserApiRow
): TReportAffiliatePayoutData => ({
  userName: row.username,
  payout: Number(row.payout),
  isTotal: row.username === 'TOTAL',
});

export const getOldAffiliatePayoutByUsers = async (
  payload: TReportAffiliatePayoutParams
): Promise<TReportAffiliatePayoutData[]> => {
  const { data } = await axios.post<TAffiliatePayoutAmountByUserApiRow[]>(
    '/reports/amember/affiliate_payout_amount_by_user/',
    payload
  );

  return data.map(mapAffiliatePayoutAmountByUserRow);
};

export const exportOldAffiliatePayoutByUsers = (
  payload: TReportAffiliatePayoutParams
): Promise<AxiosResponse<BlobPart>> => {
  return axios.post(
    '/reports/amember/affiliate_payout_amount_by_user/export/',
    payload,
    {
      responseType: 'blob',
    }
  );
};

export const getAmountOfRebills = async (
  payload: TReportCommonPayloadWithGrouping
): Promise<TReportAmountOfRebillsRes> => {
  const { data } = await axios.post('/reports/amount-of-rebills/', payload);

  return data;
};

export const exportAmountOfRebills = (
  payload: TReportCommonPayloadWithGrouping
): Promise<AxiosResponse<BlobPart>> => {
  return axios.post('/reports/amount-of-rebills/export/', payload, {
    responseType: 'blob',
  });
};

export const getAverageAmountByProductsBreakdown = async (
  payload: TReportAverageAmountByProductsBreakdownParams
): Promise<TReportAverageAmountByProductsBreakdownRes> => {
  const { data } = await axios.post(
    '/reports/average-amount-by-products-breakdown/',
    payload
  );

  return data;
};

export const exportAverageAmountByProductsBreakdown = (
  payload: TReportAverageAmountByProductsBreakdownParams,
  format: 'csv' | 'xlsx' = 'xlsx'
): Promise<AxiosResponse<BlobPart>> => {
  return axios.post(
    '/reports/average-amount-by-products-breakdown/export/',
    payload,
    {
      params: { format },
      responseType: 'blob',
    }
  );
};

type TAverageLifetimeValueApiPeriod = {
  period: number;
  average_ltv: number;
};

type TAverageLifetimeValueApiResponse = {
  grouping: 'week' | 'month' | 'quarter' | 'year';
  cohort_size: number;
  periods: TAverageLifetimeValueApiPeriod[];
  total_average_ltv: number;
};

export const getAverageLifetimeValueCohortAnalysis = async (
  payload: TReportAverageLifetimeValueCohortAnalysisParams
): Promise<TReportAverageLifetimeValueCohortAnalysisRes> => {
  const { data } = await axios.post<TAverageLifetimeValueApiResponse>(
    '/reports/average-lifetime-value/',
    payload
  );

  return {
    grouping: payload.grouping,
    cohort_size: data.cohort_size,
    total_average_ltv: data.total_average_ltv,
    data: data.periods.map((item) => ({
      cohort_period: String(item.period),
      average_lifetime_value: item.average_ltv,
    })),
  };
};

export const exportAverageLifetimeValueCohortAnalysis = (
  payload: TReportAverageLifetimeValueCohortAnalysisParams,
  format: 'csv' | 'xlsx' = 'csv'
): Promise<AxiosResponse<BlobPart>> => {
  return axios.post('/reports/average-lifetime-value/export/', payload, {
    params: { format },
    responseType: 'blob',
  });
};

export const getActiveUsersByProductCategories = async (
  payload: TReportActiveUsersByProductCategoriesPayload
): Promise<TReportActiveUsersByProductCategoriesRes> => {
  const { data } = await axios.post(
    '/reports/active-users-by-product-category',
    payload
  );

  return data;
};

export const exportActiveUsersByProductCategories = (
  payload: TReportActiveUsersByProductCategoriesPayload
): Promise<AxiosResponse<BlobPart>> => {
  return axios.post(
    '/reports/active-users-by-product-category/export',
    payload,
    {
      responseType: 'blob',
    }
  );
};

export const getActiveUsersByProducts = async (
  payload: TReportActiveUsersByProductPayload
): Promise<TReportActiveUsersByProductRes> => {
  const { data } = await axios.post(
    '/reports/active-users-by-products',
    payload
  );

  return data;
};

export const exportActiveUsersByProducts = (
  payload: TReportActiveUsersByProductPayload
): Promise<AxiosResponse<BlobPart>> => {
  return axios.post('/reports/active-users-by-products/export', payload, {
    responseType: 'blob',
  });
};

export const getCountOfPendingInvoices = async (
  payload: TReportCommonPayloadWithGroupingAndProducts
): Promise<TCommonReportWithProductsRes> => {
  const { data } = await axios.post(
    '/reports/count-of-pending-invoices/',
    payload
  );

  return data;
};

export const exportCountOfPendingInvoices = (
  payload: TReportCommonPayloadWithGroupingAndProducts
): Promise<AxiosResponse<BlobPart>> => {
  return axios.post('/reports/count-of-pending-invoices/export/', payload, {
    responseType: 'blob',
  });
};

export const getCountOfProductPurchase = async (
  payload: TReportCommonPayloadWithGroupingAndProducts
): Promise<TCommonReportWithProductsRes> => {
  const { data } = await axios.post(
    '/reports/count-of-product-purchase/',
    payload
  );

  return data;
};

export const exportCountOfProductPurchase = (
  payload: TReportCommonPayloadWithGroupingAndProducts
): Promise<AxiosResponse<BlobPart>> => {
  return axios.post('/reports/count-of-product-purchase/export/', payload, {
    responseType: 'blob',
  });
};

export const getCountOfProductPurchaseByPaymentSystem = async (
  payload: TReportCommonPayloadWithGroupingAndProducts
): Promise<TReportCountOfProductPurchaseByPaymentSystemRes> => {
  const { data } = await axios.post(
    '/reports/count-of-product-purchase-by-payment-system/',
    payload
  );

  return data;
};

export const exportCountOfProductPurchaseByPaymentSystem = (
  payload: TReportCommonPayloadWithGroupingAndProducts
): Promise<AxiosResponse<BlobPart>> => {
  return axios.post(
    '/reports/count-of-product-purchase-by-payment-system/export/',
    payload,
    {
      responseType: 'blob',
    }
  );
};

export const getCountOfSignupsUsers = async (
  payload: TReportCommonPayloadWithGrouping
): Promise<TReportCountOfUserSignupsRes> => {
  const { data } = await axios.post('/reports/count-of-user-signups/', payload);

  return data;
};

export const exportCountOfSignupsUsers = (
  payload: TReportCommonPayloadWithGrouping
): Promise<AxiosResponse<BlobPart>> => {
  return axios.post('/reports/count-of-user-signups/export/', payload, {
    responseType: 'blob',
  });
};

export const getCountOfSignupByCountry = async (
  payload: TReportCommonPayloadWithGrouping
): Promise<TReportCountOfSignupByCountryRes> => {
  const { data } = await axios.post(
    '/reports/count-of-signup-by-country/',
    payload
  );

  return data;
};

export const exportCountOfSignupByCountry = (
  payload: TReportCommonPayloadWithGrouping
): Promise<AxiosResponse<BlobPart>> => {
  return axios.post('/reports/count-of-signup-by-country/export/', payload, {
    responseType: 'blob',
  });
};

export const getPaymentsByCustomerCityOrCountryReport = async (
  payload: TReportPaymentsByCustomerCityOrCountryPayload
): Promise<TReportPaymentsByCustomerCityOrCountryRes> => {
  const { data } = await axios.post(
    '/reports/payment-by-customer-city/',
    payload
  );

  return data;
};

export const exportPaymentsByCustomerCityOrCountryReport = (
  payload: TReportPaymentsByCustomerCityOrCountryPayload
): Promise<AxiosResponse<BlobPart>> => {
  return axios.post('/reports/payment-by-customer-city/export/', payload, {
    responseType: 'blob',
  });
};

export const getCustomerCities = async (
  params: {
    search?: string;
    page?: number;
    per_page?: number;
  } = {}
): Promise<TReportPaymentsByCustomerCityOptionsRes> => {
  const { data } = await axios.get<TReportPaymentsByCustomerCityOptionsRes>(
    '/reports/payment-by-customer-city/cities',
    { params }
  );

  return data;
};

export const getPaymentsByCustomerCountryReport = async (
  payload: TReportPaymentsByCustomerCityOrCountryPayload
): Promise<TReportPaymentsByCustomerCountryRes> => {
  const { data } = await axios.post(
    '/reports/payment-by-customer-country/',
    payload
  );

  return data;
};

export const exportPaymentsByCustomerCountryReport = (
  payload: TReportPaymentsByCustomerCityOrCountryPayload
): Promise<AxiosResponse<BlobPart>> => {
  return axios.post('/reports/payment-by-customer-country/export/', payload, {
    responseType: 'blob',
  });
};

export const getCountryOptions = async (
  params: {
    search?: string;
    page?: number;
    per_page?: number;
  } = {}
): Promise<TReportPaymentsByCustomerCityOptionsRes> => {
  const { data } = await axios.get<TReportPaymentsByCustomerCityOptionsRes>(
    '/reports/payment-by-customer-country/countries',
    { params }
  );

  return data;
};

export const getPaymentByNewVsExistingUsers = async (
  params: TReportPaymentByNewVsExistingUsersParams
): Promise<TReportPaymentByNewVsExistingUsersRes> => {
  const { data } = await axios.get(
    '/reports/payment-by-new-vs-existing-users/',
    {
      params,
    }
  );

  return data;
};

export const getPaymentByUsedCoupon = async (
  payload: TReportCommonPayloadWithGrouping & { coupon_batch: number }
): Promise<TReportPaymentByUsedCouponRes> => {
  const { data } = await axios.post(
    '/reports/payments-by-used-coupon/',
    payload
  );

  return data;
};

export const getIncomeReport = async (
  payload: TReportIncomeParams
): Promise<TReportIncomeData[]> => {
  const { data } = await axios.post('/reports/income/', payload);

  return data;
};

export const exportIncomeReport = (
  payload: TReportIncomeParams,
  format: 'csv' | 'xlsx' = 'csv'
): Promise<AxiosResponse<BlobPart>> => {
  return axios.post('/reports/income/export/', payload, {
    params: { format },
    responseType: 'blob',
  });
};

export const getRollingConversionReport = async (
  payload: TReportRollingConversionParams
): Promise<TReportRollingConversionRes> => {
  const { data } = await axios.post('/reports/rolling-conversion/', payload);

  return data;
};

export const exportRollingConversionReport = (
  payload: TReportRollingConversionParams,
  format: 'csv' | 'xlsx' = 'xlsx'
): Promise<AxiosResponse<BlobPart>> => {
  return axios.post('/reports/rolling-conversion/export/', payload, {
    params: { format },
    responseType: 'blob',
  });
};

type TPaymentsVsRefundsApiRow = {
  date: string;
  payments: number;
  refunds: number;
  income: number;
  payments_previous?: number | null;
  refunds_previous?: number | null;
  income_previous?: number | null;
  payments_previous_year?: number | null;
  refunds_previous_year?: number | null;
  income_previous_year?: number | null;
};

const mapPaymentsVsRefundsRow = (
  row: TPaymentsVsRefundsApiRow
): TReportPaymentsVsRefundsData => ({
  date: row.date,
  payment: Number(row.payments ?? 0),
  refund: Number(row.refunds ?? 0),
  income: Number(row.income ?? 0),
  chargeback: 0,
  payment_previous:
    row.payments_previous === null || row.payments_previous === undefined
      ? undefined
      : Number(row.payments_previous),
  refund_previous:
    row.refunds_previous === null || row.refunds_previous === undefined
      ? undefined
      : Number(row.refunds_previous),
  income_previous:
    row.income_previous === null || row.income_previous === undefined
      ? undefined
      : Number(row.income_previous),
  payment_previous_year:
    row.payments_previous_year === null ||
    row.payments_previous_year === undefined
      ? undefined
      : Number(row.payments_previous_year),
  refund_previous_year:
    row.refunds_previous_year === null ||
    row.refunds_previous_year === undefined
      ? undefined
      : Number(row.refunds_previous_year),
  income_previous_year:
    row.income_previous_year === null || row.income_previous_year === undefined
      ? undefined
      : Number(row.income_previous_year),
});

export const getPaymentsVsRefundsReport = async (
  payload: TReportPaymentsVsRefundsParams
): Promise<TReportPaymentsVsRefundsData[]> => {
  const { data } = await axios.post<TPaymentsVsRefundsApiRow[]>(
    '/reports/payments-vs-refunds/',
    payload
  );

  return (data ?? []).map(mapPaymentsVsRefundsRow);
};

export const exportPaymentsVsRefundsReport = (
  payload: TReportPaymentsVsRefundsParams,
  format: 'csv' | 'xlsx' = 'csv'
): Promise<AxiosResponse<BlobPart>> => {
  return axios.post('/reports/payments-vs-refunds/export/', payload, {
    params: { format },
    responseType: 'blob',
  });
};

export const exportPaymentByUsedCoupon = (
  payload: TReportCommonPayloadWithGrouping & { coupon_batch: number }
): Promise<AxiosResponse<BlobPart>> => {
  return axios.post('/reports/payments-by-used-coupon/export/', payload, {
    responseType: 'blob',
  });
};

export const getRefundsByUsedCoupon = async (
  payload: TReportRefundsByUsedCouponParams
): Promise<TReportRefundsByUsedCouponRes> => {
  const { data } = await axios.post(
    '/reports/refunds-by-used-coupon-code/',
    payload
  );

  return data;
};

export const exportRefundsByUsedCoupon = (
  payload: TReportRefundsByUsedCouponParams
): Promise<AxiosResponse<BlobPart>> => {
  return axios.post('/reports/refunds-by-used-coupon-code/export/', payload, {
    responseType: 'blob',
  });
};

export const getPaymentsByUserGroups = async (
  payload: TReportPaymentByUserGroupParams
): Promise<TReportPaymentByUserGroupRes> => {
  const { data } = await axios.post(
    '/reports/payments-by-user-groups',
    payload
  );

  return data;
};

export const getPaymentsByUserGroupsGroupOptions = async (): Promise<
  TReportPaymentByUserGroupOption[]
> => {
  const { data } = await axios.get<TReportPaymentByUserGroupOption[]>(
    '/reports/payments-by-user-groups/group-options/'
  );

  return data;
};

export const exportPaymentsByUserGroups = (
  payload: TReportPaymentByUserGroupParams
): Promise<AxiosResponse<BlobPart>> => {
  return axios.post('/reports/payments-by-user-groups/export/', payload, {
    responseType: 'blob',
  });
};

export const getPaymentsByProductCategoriesBreakdown = async (
  payload: TReportPaymentsByProductCategoriesBreakdownParams
): Promise<TReportPaymentsByProductCategoriesBreakdownRes> => {
  const res = await axios.post<TReportPaymentsByProductCategoriesBreakdownRes>(
    '/reports/payments-by-product-categories/',
    payload
  );

  return res.data;
};

export const exportPaymentsByProductCategoriesBreakdown = (
  payload: TReportPaymentsByProductCategoriesBreakdownParams
): Promise<AxiosResponse<BlobPart>> => {
  return axios.post(
    '/reports/payments-by-product-categories/export/',
    payload,
    {
      responseType: 'blob',
    }
  );
};

export const getPaymentsByProductCategoriesBreakdownOptions = async (): Promise<
  TReportPaymentsByProductCategoriesBreakdownOption[]
> => {
  const res = await axios.get<
    TReportPaymentsByProductCategoriesBreakdownOption[]
  >('/reports/payments-by-product-categories/product-categories-options/');

  return res.data;
};

export const getPaymentsByProductsBreakdown = async (
  payload: TReportCommonPayloadWithGroupingAndProducts
): Promise<TCommonReportWithProductsRes> => {
  const res = await axios.post<TCommonReportWithProductsRes>(
    '/reports/payments-by-products-breakdown/',
    payload
  );

  return res.data;
};

export const exportPaymentsByProductsBreakdown = (
  payload: TReportCommonPayloadWithGroupingAndProducts
): Promise<AxiosResponse<BlobPart>> => {
  return axios.post(
    '/reports/payments-by-products-breakdown/export/',
    payload,
    {
      responseType: 'blob',
    }
  );
};

export const getCreditsSpentByProductsBreakdown = async (
  payload: TReportCreditsSpentByProductsBreakdownParams
): Promise<TReportCreditsSpentByProductsBreakdownRes> => {
  const res = await axios.post<TReportCreditsSpentByProductsBreakdownRes>(
    '/reports/credits-spent-by-products-breakdown/',
    payload
  );

  return res.data;
};

export const exportCreditsSpentByProductsBreakdown = (
  payload: TReportCreditsSpentByProductsBreakdownParams,
  format: 'csv' | 'xlsx' = 'xlsx'
): Promise<AxiosResponse<BlobPart>> => {
  return axios.post(
    '/reports/credits-spent-by-products-breakdown/export/',
    payload,
    {
      params: { format },
      responseType: 'blob',
    }
  );
};

export const getCreditsSpentByProductsBreakdownProducts = async (): Promise<
  { product_id: number; product_name: string }[]
> => {
  const res = await axios.get<{ product_id: number; product_name: string }[]>(
    '/reports/credits-spent-by-products-breakdown/products/'
  );

  return res.data;
};

export const getDownloadByFilesBreakdown = async (
  payload: TReportDownloadByFilesBreakdownParams
): Promise<TReportDownloadByFilesBreakdownRes> => {
  const res = await axios.post<TReportDownloadByFilesBreakdownRes>(
    '/reports/download-by-files-breakdown/',
    payload
  );

  return res.data;
};

export const exportDownloadByFilesBreakdown = (
  payload: TReportDownloadByFilesBreakdownParams,
  format: 'csv' | 'xlsx' = 'csv'
): Promise<AxiosResponse<BlobPart>> => {
  return axios.post('/reports/download-by-files-breakdown/export/', payload, {
    params: { format },
    responseType: 'blob',
  });
};

export const getDownloadByFilesBreakdownFiles = async (): Promise<
  TReportDownloadByFilesBreakdownFileOption[]
> => {
  const res = await axios.get<TReportDownloadByFilesBreakdownFileOption[]>(
    '/reports/download-by-files-breakdown/files/'
  );

  return res.data;
};

export const getPaymentsBySignupFormBreakdown = async (
  params: TReportPaymentsBySignupFormBreakdownParams
): Promise<TReportPaymentsBySignupFormBreakdownRes> => {
  const res = await axios.post<TPaymentsBySignupFormBreakdownApiRes>(
    '/reports/payments-by-signup-form-breakdown/',
    params
  );

  return {
    data: (res.data.data ?? []).map((item) => ({
      date: item.date,
      signup_forms: item.forms,
      signup_forms_previous: item.forms_previous,
      signup_forms_previous_year: item.forms_previous_year,
    })),
    total_by_signup_form: res.data.total_by_signup_form ?? {},
    available_signup_forms: res.data.available_signup_forms ?? [],
  };
};

type TPaymentsBySignupFormBreakdownApiData = {
  date: string;
  forms: Record<string, number>;
  forms_previous?: Record<string, number>;
  forms_previous_year?: Record<string, number>;
};

type TPaymentsBySignupFormBreakdownApiRes = {
  data: TPaymentsBySignupFormBreakdownApiData[];
  total_by_signup_form?: Record<string, number>;
  available_signup_forms?: string[];
};

export const exportPaymentsBySignupFormBreakdown = (
  payload: TReportPaymentsBySignupFormBreakdownParams,
  format: 'csv' | 'xlsx' = 'csv'
): Promise<AxiosResponse<BlobPart>> => {
  return axios.post(
    '/reports/payments-by-signup-form-breakdown/export/',
    payload,
    {
      params: { format },
      responseType: 'blob',
    }
  );
};

type TInvoicesBySignupFormApiData = {
  date: string;
  forms: Record<string, number>;
  forms_previous?: Record<string, number>;
  forms_previous_year?: Record<string, number>;
};

type TInvoicesBySignupFormApiRes = {
  data: TInvoicesBySignupFormApiData[];
};

export const getInvoicesBySignupForm = async (
  payload: TReportInvoicesBySignupFormParams
): Promise<TReportInvoicesBySignupFormRes> => {
  const res = await axios.post<TInvoicesBySignupFormApiRes>(
    '/reports/invoices-by-signup-form/',
    payload
  );

  return {
    data: res.data.data.map((item) => ({
      date: item.date,
      signup_forms: item.forms,
      signup_forms_previous: item.forms_previous,
      signup_forms_previous_year: item.forms_previous_year,
    })),
  };
};

export const exportInvoicesBySignupForm = (
  payload: TReportInvoicesBySignupFormParams,
  format: 'csv' | 'xlsx' = 'csv'
): Promise<AxiosResponse<BlobPart>> => {
  return axios.post('/reports/invoices-by-signup-form/export/', payload, {
    params: { format },
    responseType: 'blob',
  });
};

export const getInvoicesBySignupFormOptions = async (): Promise<
  TReportInvoicesBySignupFormOption[]
> => {
  const res = await axios.get<TReportInvoicesBySignupFormOption[]>(
    '/reports/invoices-by-signup-form/forms/'
  );

  return res.data;
};

export const getPaymentsMinusRefundsByCustomerCountry = async (
  payload: TReportPaymentsMinusRefundsByCustomerCountryParams
): Promise<TReportPaymentsMinusRefundsByCustomerCountryRes> => {
  const res = await axios.post<TReportPaymentsMinusRefundsByCustomerCountryRes>(
    '/reports/payments-minus-refunds-by-customer-country/',
    payload
  );

  return res.data;
};

export const exportPaymentsMinusRefundsByCustomerCountry = (
  payload: TReportPaymentsMinusRefundsByCustomerCountryParams,
  format: 'csv' | 'xlsx' = 'csv'
): Promise<AxiosResponse<BlobPart>> => {
  return axios.post(
    '/reports/payments-minus-refunds-by-customer-country/export/',
    payload,
    {
      params: { format },
      responseType: 'blob',
    }
  );
};

export const getTaxReport = async (
  payload: TReportTaxParams
): Promise<TReportTaxRes> => {
  const res = await axios.post<TReportTaxData[]>(
    '/reports/tax-report/',
    payload
  );

  return {
    data: res.data ?? [],
    total: (res.data ?? []).reduce(
      (sum, row) => sum + Number(row.tax_amount ?? 0),
      0
    ),
  };
};

export const exportTaxReport = (
  payload: TReportTaxParams,
  format: 'csv' | 'xlsx' = 'xlsx'
): Promise<AxiosResponse<BlobPart>> => {
  return axios.post('/reports/tax-report/export/', payload, {
    params: { format },
    responseType: 'blob',
  });
};

export const getTaxByCustomerCountry = async (
  payload: TReportTaxByCustomerCountryParams
): Promise<TReportTaxByCustomerCountryRes> => {
  type TTaxByCustomerCountryApiMetric = {
    payment_tax: number;
    refund_tax: number;
    net_tax: number;
  };

  type TTaxByCustomerCountryApiRow = {
    date: string;
    countries: Record<string, number | TTaxByCustomerCountryApiMetric>;
    countries_previous?: Record<
      string,
      number | TTaxByCustomerCountryApiMetric
    >;
    countries_previous_year?: Record<
      string,
      number | TTaxByCustomerCountryApiMetric
    >;
  };

  const toNetMap = (
    metrics?: Record<string, number | TTaxByCustomerCountryApiMetric>
  ) => {
    if (!metrics) return undefined;

    return Object.fromEntries(
      Object.entries(metrics).map(([country, value]) => [
        country,
        Number(typeof value === 'number' ? value : (value?.net_tax ?? 0)),
      ])
    );
  };

  const res = await axios.post<TTaxByCustomerCountryApiRow[]>(
    '/reports/tax-by-customer-country/',
    payload
  );

  const data = (res.data ?? []).map((row) => ({
    date: row.date,
    countries: toNetMap(row.countries) ?? {},
    countries_previous: toNetMap(row.countries_previous),
    countries_previous_year: toNetMap(row.countries_previous_year),
  }));

  const totalByCountry: Record<string, number> = {};
  const availableCountriesSet = new Set<string>();

  data.forEach((row) => {
    Object.entries(row.countries).forEach(([country, netTax]) => {
      availableCountriesSet.add(country);
      totalByCountry[country] = (totalByCountry[country] || 0) + Number(netTax);
    });
  });

  return {
    data,
    total_by_country: totalByCountry,
    available_countries: Array.from(availableCountriesSet).sort(),
  };
};

export const exportTaxByCustomerCountry = (
  payload: TReportTaxByCustomerCountryParams,
  format: 'csv' | 'xlsx' = 'csv'
): Promise<AxiosResponse<BlobPart>> => {
  return axios.post('/reports/tax-by-customer-country/export/', payload, {
    params: { format },
    responseType: 'blob',
  });
};

export const getTaxByCustomerState = async (
  params: TReportTaxByCustomerStateParams
): Promise<TReportTaxByCustomerStateRes> => {
  const res = await axios.post<TReportTaxByCustomerStateData[]>(
    '/reports/tax-by-customer-state/',
    params
  );

  const data = res.data ?? [];

  const totalByState: Record<string, number> = {};
  const availableStatesSet = new Set<string>();

  data.forEach((row) => {
    Object.entries(row.states).forEach(([state, netTax]) => {
      availableStatesSet.add(state);
      totalByState[state] = (totalByState[state] || 0) + Number(netTax);
    });
  });

  return {
    data,
    total_by_state: totalByState,
    available_states: Array.from(availableStatesSet),
  };
};

export const exportTaxByCustomerState = (
  payload: TReportTaxByCustomerStateParams,
  format: 'csv' | 'xlsx' = 'xlsx'
): Promise<AxiosResponse<BlobPart>> => {
  return axios.post('/reports/tax-by-customer-state/export/', payload, {
    params: { format },
    responseType: 'blob',
  });
};

export const getProductConversion = async (
  payload: TReportProductConversionParams
): Promise<TReportProductConversionRes> => {
  type TProductConversionApiRow = {
    date: string;
    conversion_rate: number;
    revenue: number;
    conversion_rate_previous?: number | null;
    revenue_previous?: number | null;
    conversion_rate_previous_year?: number | null;
    revenue_previous_year?: number | null;
  };

  const mapProductConversionRow = (
    row: TProductConversionApiRow
  ): TReportProductConversionRes[number] => ({
    date: row.date,
    conversion_percentage: Number(row.conversion_rate ?? 0),
    revenue: Number(row.revenue ?? 0),
    conversion_percentage_previous:
      row.conversion_rate_previous === null ||
      row.conversion_rate_previous === undefined
        ? undefined
        : Number(row.conversion_rate_previous),
    revenue_previous:
      row.revenue_previous === null || row.revenue_previous === undefined
        ? undefined
        : Number(row.revenue_previous),
    conversion_percentage_previous_year:
      row.conversion_rate_previous_year === null ||
      row.conversion_rate_previous_year === undefined
        ? undefined
        : Number(row.conversion_rate_previous_year),
    revenue_previous_year:
      row.revenue_previous_year === null ||
      row.revenue_previous_year === undefined
        ? undefined
        : Number(row.revenue_previous_year),
  });

  const { data } = await axios.post<TProductConversionApiRow[]>(
    '/reports/product-conversion/',
    payload
  );

  return (data ?? []).map(mapProductConversionRow);
};

export const exportProductConversion = (
  payload: TReportProductConversionParams,
  format: 'csv' | 'xlsx' = 'csv'
): Promise<AxiosResponse<BlobPart>> => {
  return axios.post('/reports/product-conversion/export/', payload, {
    params: { format },
    responseType: 'blob',
  });
};

export const getUserDistributionByCustomFieldByDate = async (
  payload: TReportUserDistributionByCustomFieldByDateParams
): Promise<TReportUserDistributionByCustomFieldByDateRes> => {
  type TUserDistributionByDateApiRow = {
    date: string;
    field_values: Record<string, number>;
    field_values_previous?: Record<string, number>;
    field_values_previous_year?: Record<string, number>;
  };

  const { data } = await axios.post<TUserDistributionByDateApiRow[]>(
    '/reports/user-distribution-by-custom-field-by-date/',
    payload
  );

  return (data ?? []).map((item) => ({
    date: item.date,
    field_values: item.field_values ?? {},
    field_values_previous: item.field_values_previous,
    field_values_previous_year: item.field_values_previous_year,
  }));
};

export const exportUserDistributionByCustomFieldByDate = (
  payload: TReportUserDistributionByCustomFieldByDateParams,
  format: 'csv' | 'xlsx' = 'csv'
): Promise<AxiosResponse<BlobPart>> => {
  return axios.post(
    '/reports/user-distribution-by-custom-field-by-date/export/',
    payload,
    {
      params: { format },
      responseType: 'blob',
    }
  );
};

export const getRefundsRate = async (
  payload: TReportCommonPayloadWithGrouping
): Promise<TReportRefundsRateRes> => {
  const res = await axios.post<TReportRefundsRateRes>(
    '/reports/refunds-rate/',
    payload
  );

  return res.data;
};

export const exportRefundsRate = (
  payload: TReportCommonPayloadWithGrouping
): Promise<AxiosResponse<BlobPart>> => {
  return axios.post('/reports/refunds-rate/export/', payload, {
    responseType: 'blob',
  });
};

export const getRefundsByCustomerCountry = async (
  payload: TReportRefundsByCustomerCountryParams
): Promise<TReportRefundsByCustomerCountryRes> => {
  const res = await axios.post<TReportRefundsByCustomerCountryRes>(
    '/reports/refunds-by-customer-country/',
    payload
  );

  return res.data;
};

export const exportRefundsByCustomerCountry = (
  payload: TReportRefundsByCustomerCountryParams
): Promise<AxiosResponse<BlobPart>> => {
  return axios.post('/reports/refunds-by-customer-country/export/', payload, {
    responseType: 'blob',
  });
};

export const getUserDemographicsReport = async (
  params: TReportUserDemographicsParams
): Promise<TReportUserDemographicsRes> => {
  const { data } = await axios.get('/reports/user-demographic/', {
    params,
  });

  return data;
};

export const exportUserDemographicsReport = (
  params: TReportUserDemographicsParams
): Promise<AxiosResponse<BlobPart>> => {
  return axios.get('/reports/user-demographic/export/', {
    params,
    responseType: 'blob',
  });
};

export const getPaymentDistributionByCustomerCountryReport = async (
  payload: TReportPaymentDistributionByCustomerCountryParams
): Promise<{
  data: TReportPaymentDistributionByCustomerCountryData[];
}> => {
  const { data } = await axios.post(
    '/reports/payment-distribution-by-customer-country/',
    payload
  );

  return data;
};

export const exportPaymentDistributionByCustomerCountryReport = (
  payload: TReportPaymentDistributionByCustomerCountryParams
): Promise<AxiosResponse<BlobPart>> => {
  return axios.post(
    '/reports/payment-distribution-by-customer-country/export/',
    payload,
    {
      responseType: 'blob',
    }
  );
};

export const getRefundsDistributionByCustomerCountryReport = async (
  payload: TReportRefundsDistributionByCustomerCountryParams
): Promise<TReportRefundsDistributionByCustomerCountryRes> => {
  const { data } =
    await axios.post<TReportRefundsDistributionByCustomerCountryRes>(
      '/reports/refunds-distribution-by-customer-country/',
      payload
    );

  return data;
};

export const exportRefundsDistributionByCustomerCountryReport = (
  payload: TReportRefundsDistributionByCustomerCountryParams
): Promise<AxiosResponse<BlobPart>> => {
  return axios.post(
    '/reports/refunds-distribution-by-customer-country/export/',
    payload,
    {
      responseType: 'blob',
    }
  );
};

export const getCountOfCancellations = async (
  payload: TReportCommonPayloadWithGroupingAndProducts
): Promise<{
  data: TCommonReportWithProductsData[];
}> => {
  const { data } = await axios.post(
    '/reports/count-of-cancellations/',
    payload
  );

  return data;
};

export const exportCountOfCancellations = (
  payload: TReportCommonPayloadWithGroupingAndProducts
): Promise<AxiosResponse<BlobPart>> => {
  return axios.post('/reports/count-of-cancellations/export/', payload, {
    responseType: 'blob',
  });
};

type TChurnRateApiData = {
  date: string;
  churn_count: Record<string, number>;
  churn_count_previous?: Record<string, number>;
  churn_count_previous_year?: Record<string, number>;
};

type TChurnRateApiRes = {
  data: TChurnRateApiData[];
};

export const getChurnRate = async (
  payload: TReportCommonPayloadWithGroupingAndProducts
): Promise<TCommonReportWithProductsRes> => {
  const { data } = await axios.post<TChurnRateApiRes>(
    '/report/churn-rate/',
    payload
  );

  return {
    data: data.data.map((item) => ({
      date: item.date,
      products: item.churn_count,
      products_previous: item.churn_count_previous,
      products_previous_year: item.churn_count_previous_year,
    })),
  };
};

export const exportChurnRate = (
  payload: TReportCommonPayloadWithGroupingAndProducts
): Promise<AxiosResponse<BlobPart>> => {
  return axios.post('/report/churn-rate/export/', payload, {
    responseType: 'blob',
  });
};

export const getPaymentsByPaymentSystemBreakdown = async (
  payload: TReportPaymentsByPaymentSystemBreakdownParams
): Promise<TReportPaymentsByPaymentSystemBreakdownRes> => {
  const res = await axios.post<TReportPaymentsByPaymentSystemBreakdownRes>(
    '/reports/payments-by-payment-system-breakdown/',
    payload
  );

  return res.data;
};

export const exportPaymentsByPaymentSystemBreakdown = (
  payload: TReportPaymentsByPaymentSystemBreakdownParams
): Promise<AxiosResponse<BlobPart>> => {
  return axios.post(
    '/reports/payments-by-payment-system-breakdown/export/',
    payload,
    {
      responseType: 'blob',
    }
  );
};

export const getRefundsByPaymentSystemBreakdown = async (
  payload: TReportRefundsByPaymentSystemBreakdownParams
): Promise<TReportRefundsByPaymentSystemBreakdownRes> => {
  const res = await axios.post<TReportRefundsByPaymentSystemBreakdownRes>(
    '/reports/refunds-by-payment-system-breakdown/',
    payload
  );

  return res.data;
};

export const exportRefundsByPaymentSystemBreakdown = (
  payload: TReportRefundsByPaymentSystemBreakdownParams
): Promise<AxiosResponse<BlobPart>> => {
  return axios.post(
    '/reports/refunds-by-payment-system-breakdown/export/',
    payload,
    {
      responseType: 'blob',
    }
  );
};

export const getRefundsByProductBreakdown = async (
  payload: TReportRefundsByProductsBreakdownParams
): Promise<TReportRefundsByProductsBreakdownRes> => {
  const res = await axios.post<TReportRefundsByProductsBreakdownRes>(
    '/reports/refunds-by-product-breakdown/',
    payload
  );

  return res.data;
};

export const exportRefundsByProductBreakdown = (
  payload: TReportRefundsByProductsBreakdownParams
): Promise<AxiosResponse<BlobPart>> => {
  return axios.post('/reports/refunds-by-product-breakdown/export/', payload, {
    responseType: 'blob',
  });
};

export const getRefundsByProductCategoriesBreakdown = async (
  payload: TReportRefundsByProductCategoriesBreakdownParams
): Promise<TReportRefundsByProductCategoriesBreakdownRes> => {
  const res = await axios.post<TReportRefundsByProductCategoriesBreakdownRes>(
    '/reports/refunds-by-product-category-breakdown/',
    payload
  );

  return res.data;
};

export const exportRefundsByProductCategoriesBreakdown = (
  payload: TReportRefundsByProductCategoriesBreakdownParams
): Promise<AxiosResponse<BlobPart>> => {
  return axios.post(
    '/reports/refunds-by-product-category-breakdown/export/',
    payload,
    {
      responseType: 'blob',
    }
  );
};

export const getRefundsByProductCategoriesBreakdownProductCategories =
  async (): Promise<TReportRefundsByProductCategoriesBreakdownOption[]> => {
    const res = await axios.get<
      TReportRefundsByProductCategoriesBreakdownOption[]
    >('/reports/refunds-by-product-category-breakdown/product-categories/');

    return res.data;
  };

export const getConversionRateByPaymentSystemBreakdown = async (
  payload: TReportConversionRateByPaymentSystemBreakdownParams
): Promise<TReportConversionRateByPaymentSystemBreakdownRes> => {
  const res =
    await axios.post<TReportConversionRateByPaymentSystemBreakdownRes>(
      '/reports/conversion-rate-by-payment-system-breakdown/',
      payload
    );

  return res.data;
};

export const exportConversionRateByPaymentSystemBreakdown = (
  payload: TReportConversionRateByPaymentSystemBreakdownParams,
  format: 'csv' | 'xlsx' = 'xlsx'
): Promise<AxiosResponse<BlobPart>> => {
  return axios.post(
    '/reports/conversion-rate-by-payment-system-breakdown/export/',
    payload,
    {
      params: { format },
      responseType: 'blob',
    }
  );
};

// E-commerce Dashboard Drill-down APIs

export const getRevenueBreakdown = async (payload: {
  start_date?: string | null;
  end_date?: string | null;
}): Promise<TReportRevenueBreakdownRes> => {
  const res = await axios.post<TReportRevenueBreakdownRes>(
    '/reports/ecommerce-dashboard/revenue/breakdown/',
    payload
  );

  return res.data;
};

export const getTopSellingProducts = async (payload: {
  start_date?: string | null;
  end_date?: string | null;
}): Promise<TReportTopSellingProductsRes> => {
  const res = await axios.post<TReportTopSellingProductsRes>(
    '/reports/ecommerce-dashboard/products/top-selling/',
    payload
  );

  return res.data;
};

export const getLTVDistribution = async (payload: {
  start_date?: string | null;
  end_date?: string | null;
}): Promise<TReportLTVDistributionRes> => {
  const res = await axios.post<TReportLTVDistributionRes>(
    '/reports/ecommerce-dashboard/ltv/distribution/',
    payload
  );

  return res.data;
};

export const getEcommerceDashboardSummary = async (payload: {
  start_date?: string | null;
  end_date?: string | null;
}): Promise<TEcommerceDashboardSummaryRes> => {
  const res = await axios.post<TEcommerceDashboardSummaryRes>(
    '/reports/ecommerce-dashboard/summary/',
    payload
  );

  return res.data;
};

export const getEcommerceDashboardChart = async (payload: {
  start_date?: string | null;
  end_date?: string | null;
}): Promise<TEcommerceDashboardChartRes> => {
  const res = await axios.post<TEcommerceDashboardChartRes>(
    '/reports/ecommerce-dashboard/chart/',
    payload
  );

  return res.data;
};

export const getPayoutDashboardSummary =
  async (): Promise<TPayoutDashboardSummaryRes> => {
    const res = await axios.get<TPayoutDashboardSummaryRes>(
      '/reports/payout-dashboard/summary/'
    );

    return res.data;
  };

export const getPayoutDashboardChart = async (payload: {
  start_date?: string | null;
  end_date?: string | null;
}): Promise<TPayoutDashboardChartRes> => {
  const res = await axios.post<TPayoutDashboardChartRes>(
    '/reports/payout-dashboard/chart/',
    payload
  );

  return res.data;
};

export const getPaymentsByNewVsExistingUsers = async (
  payload: TReportCommonPayloadWithGrouping
): Promise<TReportPaymentByNewVsExistingUsersRes> => {
  const { data } = await axios.post(
    '/reports/payment-by-new-vs-existing-customers/',
    payload
  );

  return data;
};

export const exportPaymentsByNewVsExistingUsers = (
  payload: TReportCommonPayloadWithGrouping
): Promise<AxiosResponse<BlobPart>> => {
  return axios.post(
    '/reports/payment-by-new-vs-existing-customers/export/',
    payload,
    {
      responseType: 'blob',
    }
  );
};

export const getLeaderBoard = async (
  payload: TReportLeaderBoardParams
): Promise<TReportLeaderBoardRes> => {
  const { data } = await axios.post('/reports/leader-board/', payload);

  return data;
};

export const exportLeaderBoard = (
  payload: TReportLeaderBoardParams
): Promise<AxiosResponse<BlobPart>> => {
  return axios.post('/reports/leader-board/export/', payload, {
    responseType: 'blob',
  });
};

export const getEvalsToPa = async (
  params?: TReportEvalsToPaParams
): Promise<TReportEvalsToPaRes> => {
  const { data } = await axios.get('/reports/evals-to-pa/', { params });

  return data;
};

export const exportEvalsToPa = (
  params?: TReportEvalsToPaParams
): Promise<AxiosResponse<BlobPart>> => {
  return axios.get('/reports/evals-to-pa/export/', {
    params,
    responseType: 'blob',
  });
};

export const getEvalAccountByMonth = async (
  params: TReportEvalAccountByMonthParams
): Promise<TReportEvalAccountByMonthRes> => {
  const { data } = await axios.get('/reports/eval-account-by-month/', {
    params,
  });

  return data;
};

export const getPANewRenewalResetByMonth = async (
  params: TReportPANewRenewalResetByMonthParams
): Promise<TReportPANewRenewalResetByMonthRes> => {
  const { data } = await axios.get('/reports/new-pa-account-by-month/', {
    params,
  });

  return data;
};

export const getPaNewAccountByDate = async (
  params: TPaNewAccountByDateParams
): Promise<TPaNewAccountByDateRes> => {
  const { data } = await axios.get('/reports/pa-new-by-date/', {
    params: {
      ...params,
      page: params.page ?? 1,
      page_size: params.page_size ?? 20,
    },
  });

  return data;
};

export const exportPaNewAccountByDate = (
  params: TPaNewAccountByDateParams
): Promise<AxiosResponse<BlobPart>> => {
  return axios.get('/reports/pa-new-by-date/export/', {
    params,
    responseType: 'blob',
  });
};

export const getPaReset = async (
  payload: TPaResetParams
): Promise<TPaResetRes> => {
  const { data } = await axios.post('/reports/pa-reset/', {
    ...payload,
    page: payload.page ?? 1,
    page_size: payload.page_size ?? 20,
  });

  return data;
};

export const exportPaReset = (
  payload: TPaResetParams
): Promise<AxiosResponse<BlobPart>> => {
  return axios.post('/reports/pa-reset/export/', payload, {
    responseType: 'blob',
  });
};

export const getStaffFreebie = async (
  payload: TStaffFreebieParams
): Promise<TStaffFreebieRes> => {
  const { data } = await axios.post('/reports/staff-freebie/', payload);

  return data;
};

export const exportStaffFreebie = (
  payload: TStaffFreebieParams
): Promise<AxiosResponse<BlobPart>> => {
  return axios.post('/reports/staff-freebie/export/', payload, {
    responseType: 'blob',
  });
};

export const getPAAccountDailyPnl = async (
  params?: TPADailyPLParams
): Promise<TPADailyPLRes> => {
  const { data } = await axios.get('/reports/pa-account-daily-pnl/', {
    params,
  });

  return data;
};

export const getEvalAccountAnalysis = async (
  params?: TReportEvalAccountAnalysisParams
): Promise<TReportEvalAccountAnalysisRes> => {
  const { data } = await axios.get('/reports/eval-account-analysis/', {
    params,
  });

  return data;
};

export const exportEvalAccountAnalysis = (
  params: TReportEvalAccountAnalysisParams
): Promise<AxiosResponse<BlobPart>> => {
  return axios.get('/reports/eval-account-analysis/export/', {
    params,
    responseType: 'blob',
  });
};

export const getBundlePAAccounts = async (
  params: TBundlesPAAccountsParams
): Promise<TBundlePAAccountRes> => {
  const { data } = await axios.get('/reports/bundle-pa-account/', {
    params,
  });

  return data;
};

export const exportBundlePAAccounts = (
  params: TBundlesPAAccountsParams
): Promise<AxiosResponse<BlobPart>> => {
  return axios.get('/reports/bundle-pa-account/export/', {
    params,
    responseType: 'blob',
  });
};

export const getOneDayProfit = async (
  params?: TReportOneDayProfitParams
): Promise<TReportOneDayProfitRes> => {
  const { data } = await axios.get('/reports/one-day-profit/', {
    params,
  });

  return data;
};

export const exportOneDayProfit = (
  params?: TReportOneDayProfitParams
): Promise<AxiosResponse<BlobPart>> => {
  return axios.get('/reports/one-day-profit/export/', {
    params,
    responseType: 'blob',
  });
};

export const getActiveLifetimePA = async (
  params?: TActiveLifetimePAParams
): Promise<TActiveLifetimePARes> => {
  const { data } = await axios.get('/reports/active-lifetime-pa/', {
    params,
  });

  return data;
};

export const exportActiveLifetimePA = (
  params?: TActiveLifetimePAParams
): Promise<AxiosResponse<BlobPart>> => {
  return axios.get('/reports/active-lifetime-pa/export/', {
    params,
    responseType: 'blob',
  });
};

export const getPAProfitableTraders =
  async (): Promise<TReportProfitableTradersRes> => {
    const { data } = await axios.get('/reports/pa-profitable-traders/');

    return data;
  };

export const exportPAProfitableTraders = (): Promise<
  AxiosResponse<BlobPart>
> => {
  return axios.get('/reports/pa-profitable-traders/export/', {
    responseType: 'blob',
  });
};

export const getPAProfitableTradersV2 = async (
  payload: TReportProfitableTradersV2Params
): Promise<TReportProfitableTradersV2Res> => {
  const { data } = await axios.post('/reports/profitable-traders-v2/', payload);

  return data;
};

export const exportPAProfitableTradersV2 = (
  payload: TReportProfitableTradersV2Params
): Promise<AxiosResponse<BlobPart>> => {
  return axios.post('/reports/profitable-traders-v2/export/', payload, {
    responseType: 'blob',
  });
};

export const getPAPlnAnalysis = async (
  params?: TPAPlnAnalysisParams
): Promise<TPAPlnAnalysisRes> => {
  const { data } = await axios.get('/reports/pa-pnl-analysis/', {
    params: {
      ...params,
      fetch_all: params?.fetch_all ?? true,
    },
  });

  return data;
};

export const exportPAPlnAnalysis = (
  params?: TPAPlnAnalysisParams
): Promise<AxiosResponse<BlobPart>> => {
  return axios.get('/reports/pa-pnl-analysis/export/', {
    params: {
      ...params,
      fetch_all: params?.fetch_all ?? true,
    },
    responseType: 'blob',
  });
};

export const getPaPayoutAnalysis = async (
  params: TPaPayoutAnalysisParams
): Promise<TPaPayoutAnalysisRes> => {
  const { data } = await axios.get('/reports/pa-payout-analysis/', {
    params,
  });

  return data;
};

export const exportPaPayoutAnalysis = (
  params: TPaPayoutAnalysisParams
): Promise<AxiosResponse<BlobPart>> => {
  return axios.get('/reports/pa-payout-analysis/export/', {
    params,
    responseType: 'blob',
  });
};

export const getPAActivePayoutsAddons = async (
  params: TPAActivePayoutsAddonsRequest
): Promise<TPAActivePayoutsAddonsApiRes> => {
  const { data } = await axios.get<TPAActivePayoutsAddonsApiRes>(
    '/reports/pa-active-account-with-payout-addons/',
    { params }
  );

  return data;
};

export const exportPAActivePayoutsAddons = (
  params: TPAActivePayoutsAddonsRequest
): Promise<AxiosResponse<BlobPart>> => {
  return axios.get('/reports/pa-active-account-with-payout-addons/export/', {
    params,
    responseType: 'blob',
  });
};

export const getExpressPAAccountRefund = async (
  params: TExpressPAAccountRefundParams
): Promise<TExpressPAAccountRefundRes> => {
  const { data } = await axios.get('/reports/express-pa-account-refund/', {
    params,
  });

  return data;
};

export const exportExpressPAAccountRefund = (
  params: TExpressPAAccountRefundParams
): Promise<AxiosResponse<BlobPart>> => {
  return axios.get('/reports/express-pa-account-refund/export/', {
    params,
    responseType: 'blob',
  });
};

export const getAveragePaymentsByUserGroup = async (
  payload: TAveragePaymentsByUserGroupRequest
): Promise<TAveragePaymentsByUserGroupResponse> => {
  const { data } = await axios.post(
    '/reports/average-payments-by-user-group/',
    payload
  );

  return data;
};

export const exportAveragePaymentsByUserGroup = (
  payload: TAveragePaymentsByUserGroupRequest
): Promise<AxiosResponse<BlobPart>> => {
  return axios.post(
    '/reports/average-payments-by-user-group/export/',
    payload,
    {
      responseType: 'blob',
    }
  );
};

export const getNumberOfPaymentsByBillingPlan = async (
  payload: TReportCommonPayloadWithGroupingAndProducts
): Promise<TReportNumberOfPaymentsByBillingPlanRes> => {
  const { data } = await axios.post<TReportNumberOfPaymentsByBillingPlanRes>(
    '/reports/number-of-payments-by-billing-plan/',
    payload
  );

  return data;
};

export const exportNumberOfPaymentsByBillingPlan = (
  payload: TReportCommonPayloadWithGroupingAndProducts
): Promise<AxiosResponse<BlobPart>> => {
  return axios.post(
    '/reports/number-of-payments-by-billing-plan/export/',
    payload,
    {
      responseType: 'blob',
    }
  );
};

export const getNumberOfRebills = async (
  payload: TReportCommonPayloadWithGrouping
): Promise<TReportNumberOfRebillsRes> => {
  const { data } = await axios.post<TReportNumberOfRebillsRes>(
    '/reports/number-of-rebills/',
    payload
  );

  return data;
};

export const exportNumberOfRebills = (
  payload: TReportCommonPayloadWithGrouping
): Promise<AxiosResponse<BlobPart>> => {
  return axios.post('/reports/number-of-rebills/export/', payload, {
    responseType: 'blob',
  });
};

export const getUsersByUserGroups = async (
  payload: Record<string, never>
): Promise<TReportUsersByUserGroupsRes> => {
  const { data } = await axios.post<TReportUsersByUserGroupsRes>(
    '/reports/users-by-user-groups/',
    payload
  );

  return data;
};

export const exportUsersByUserGroups = (
  format: 'csv' | 'xlsx' = 'xlsx'
): Promise<AxiosResponse<BlobPart>> => {
  return axios.post(
    '/reports/users-by-user-groups/export/',
    {},
    {
      params: { format },
      responseType: 'blob',
    }
  );
};

export const getUserLifetime = async (payload: {
  group_period_days: number;
}): Promise<TReportUserLifetimeRes> => {
  const { data } = await axios.post<TReportUserLifetimeRes>(
    '/reports/user-lifetime/',
    payload
  );

  return data;
};

export const exportUserLifetime = (payload: {
  group_period_days: number;
}): Promise<AxiosResponse<BlobPart>> => {
  return axios.post('/reports/user-lifetime/export/', payload, {
    responseType: 'blob',
  });
};

export const getPayoutsTotalsReport =
  async (): Promise<TPayoutsTotalsReportResponse> => {
    const { data } = await axios.post<TPayoutsTotalsReportResponse>(
      '/reports/payout-total-all-time/',
      {}
    );

    return data;
  };

export const getCancelFeedback = async (payload: {
  start_date: string;
  end_date: string;
}): Promise<TReportCancelFeedbackData[]> => {
  const { data } = await axios.post<TReportCancelFeedbackRes>(
    '/reports/cancel-feedback/',
    payload
  );

  return data.data ?? [];
};

export const exportCancelFeedback = (payload: {
  start_date: string;
  end_date: string;
}): Promise<AxiosResponse<BlobPart>> => {
  return axios.post('/reports/cancel-feedback/export/', payload, {
    responseType: 'blob',
  });
};
